import {remCalc} from '../_utils'

const spacing = {
    xxxsmall: {
        base: remCalc(4),
        sm: remCalc(4),
        md: remCalc(4),
        lg: remCalc(4),
    },
    xxsmall: {
        base: remCalc(8),
        sm: remCalc(8),
        md: remCalc(8),
        lg: remCalc(8),
    },
    xsmall: {
        base: remCalc(8),
        sm: remCalc(8),
        md: remCalc(8),
        lg: remCalc(16),
    },
    small: {
        base: remCalc(16),
        sm: remCalc(16),
        md: remCalc(16),
        lg: remCalc(24),
    },
    medium: {
        base: remCalc(24),
        sm: remCalc(24),
        md: remCalc(24),
        lg: remCalc(32),
    },
    large: {
        base: remCalc(64),
        sm: remCalc(64),
        md: remCalc(64),
        lg: remCalc(96),
    },
    xlarge: {
        base: remCalc(96),
        sm: remCalc(96),
        md: remCalc(96),
        lg: remCalc(128),
    },
}

export default spacing
